/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-26 16:28:18
 *
 * LastModified: 2017-05-26 16:28:18
 *-------------------------------------------------------*/

import { take, call, put, fork } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getUserInfoFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { userId }, next } = yield take('GET_USER_INFO');
    try {
      const response = yield call(fetchApi, `Accounts/${userId}?filter=${JSON.stringify({ include: { relation: 'store' } })}`)

      if (response && !response.error) {
        yield put({ type: 'GET_USER_INFO_SUCCESS', payload: response });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* changePasswordFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('CHANGE_PASSWORD');
    try {
      const response = yield call(fetchApi, `Accounts/change-password`, payload, { method: 'POST' });
      if (response && !response.error) {
        // yield put({ type: 'GET_USER_INFO_SUCCESS', payload: response });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

export default function* profileFlow() {
  yield fork(getUserInfoFlow);
  yield fork(changePasswordFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/profile/saga/index.js